export var CALLOUT_COLORS = {
  informative: {
    text: {
      light: 'tw-text-info-600',
      dark: ''
    },
    leftBorder: {
      light: 'tw-bg-info-500',
      dark: 'dark:tw-bg-info-300'
    },
    otherBordersDark: 'tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-l-0 dark:tw-border-[0.1rem] dark:tw-border-info-300',
    allBorders: 'tw-rounded-1 tw-border-[0.1rem] tw-border-info-500 dark:tw-border-info-300',
    background: 'tw-bg-info-100'
  },
  success: {
    text: {
      light: 'tw-text-success-500',
      dark: ''
    },
    leftBorder: {
      light: 'tw-bg-success-500',
      dark: 'dark:tw-bg-success-300'
    },
    otherBordersDark: 'tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-l-0 dark:tw-border-[0.1rem] dark:tw-border-success-400',
    allBorders: 'tw-rounded-1 tw-border-[0.1rem] tw-border-success-500 dark:tw-border-success-400',
    background: 'tw-bg-success-100'
  },
  warning: {
    text: {
      light: 'tw-text-on-hold-500',
      dark: ''
    },
    leftBorder: {
      light: 'tw-bg-on-hold-500',
      dark: 'dark:tw-bg-on-hold-300'
    },
    otherBordersDark: 'tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-l-0 dark:tw-border-[0.1rem] dark:tw-border-on-hold-300',
    allBorders: 'tw-rounded-1 tw-border-[0.1rem] tw-border-on-hold-500 dark:tw-border-on-hold-300',
    background: 'tw-bg-on-hold-100'
  },
  error: {
    text: {
      light: 'tw-text-alert-500',
      dark: ''
    },
    leftBorder: {
      light: 'tw-bg-alert-500',
      dark: 'dark:tw-bg-alert-300'
    },
    otherBordersDark: 'tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-l-0 dark:tw-border-[0.1rem] dark:tw-border-alert-300',
    allBorders: 'tw-rounded-1 tw-border-[0.1rem] tw-border-alert-500 dark:tw-border-alert-300',
    background: 'tw-bg-alert-100'
  }
};